import React from 'react';
import ScrollHint from '../ScrollHint';

function BackgroundStyleSelector({
  backgroundStyle,
  teamColors,
  onBackgroundStyleChange,
}) {
  return (
    <div className="background-style-selector">
      <label>Background Style</label>
      <div className="style-carousel-wrapper">
        <ScrollHint />
        <div className="style-carousel">
          <button
            type="button"
            className={`style-option-btn ${
              backgroundStyle === 'linear-gradient' ? 'active' : ''
            }`}
            onClick={() => onBackgroundStyleChange('linear-gradient')}
          >
            <div
              className="style-preview"
              style={{
                background: `linear-gradient(135deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`,
              }}
            ></div>
            <span className="style-name">Linear</span>
          </button>

          <button
            type="button"
            className={`style-option-btn ${
              backgroundStyle === 'radial-gradient' ? 'active' : ''
            }`}
            onClick={() => onBackgroundStyleChange('radial-gradient')}
          >
            <div
              className="style-preview"
              style={{
                background: `radial-gradient(circle at center, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`,
              }}
            ></div>
            <span className="style-name">Radial</span>
          </button>

          <button
            type="button"
            className={`style-option-btn ${
              backgroundStyle === 'diagonal-gradient' ? 'active' : ''
            }`}
            onClick={() => onBackgroundStyleChange('diagonal-gradient')}
          >
            <div
              className="style-preview"
              style={{
                background: `linear-gradient(45deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`,
              }}
            ></div>
            <span className="style-name">Diagonal</span>
          </button>

          <button
            type="button"
            className={`style-option-btn ${
              backgroundStyle === 'split-two-tone' ? 'active' : ''
            }`}
            onClick={() => onBackgroundStyleChange('split-two-tone')}
          >
            <div
              className="style-preview"
              style={{
                background: `linear-gradient(90deg, ${teamColors.primary} 0%, ${teamColors.primary} 50%, ${teamColors.secondary} 50%, ${teamColors.secondary} 100%)`,
              }}
            ></div>
            <span className="style-name">Split</span>
          </button>

          <button
            type="button"
            className={`style-option-btn ${
              backgroundStyle === 'solid-primary' ? 'active' : ''
            }`}
            onClick={() => onBackgroundStyleChange('solid-primary')}
          >
            <div
              className="style-preview"
              style={{
                background: teamColors.primary,
              }}
            ></div>
            <span className="style-name">Primary</span>
          </button>

          <button
            type="button"
            className={`style-option-btn ${
              backgroundStyle === 'solid-secondary' ? 'active' : ''
            }`}
            onClick={() => onBackgroundStyleChange('solid-secondary')}
          >
            <div
              className="style-preview"
              style={{
                background: teamColors.secondary,
              }}
            ></div>
            <span className="style-name">Secondary</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default BackgroundStyleSelector;
